import { render, staticRenderFns } from "./XButton.vue?vue&type=template&id=333ef1f0&"
import script from "./XButton.vue?vue&type=script&lang=ts&"
export * from "./XButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports